export default {
    excess:"Önrész kötelezettség",
    security:"Biztonsági letét",
    fuel_policy:"Üzemanyag irányelv",
    like_for_like:"Kiadott üzemanyag szinttel megegyező mennyiséggel leadni",
    full_to_full:"Kiadott üzemanyag szinttel megegyező mennyiséggel leadni",
    mileage:"Futásteljesítmény: {mileage} km a bérlésben",
    unlimited_mileage:"Korlátlan futásteljesítmény",
    non_refundable:"Nem visszatérítendő",
    free_cancellation_until:"Ingyenesen lemondható amíg: Ingyenes lemondás a következő időpontig",
    cancellation_with_terms:"Lemondás a következőkkel összhangban ",
    t_c_text:"ÁSZF",
    two_free_extras:"Kettő ingyenes extra: kettő ingyenes extra az átvételkor",
    glass_tyres_covered:"Az üveg és a gumiabroncs kár fedezve"
}